<template>
  <div class="sidebar-card">
    <h3>Infos carte SIM</h3>
    <div>
      <div v-if="$store.state.core.subscriber == null">
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
      </div>
      <div v-if="$store.state.core.subscriber != null">
        <div class="sidebar-sim-line">
          <i class=" kgk-mtn-sim-card"></i>
          <div>
            <span>{{ crop_prefix($store.state.core.subscriber.infos.msisdn) }}</span>
            <i v-if="$store.state.core.subscriber.is_registered == true" class=" kgk-mtn-verified ml-1" style="color: #14b6ed;"></i>
          </div>
        </div>
        <div>
          <b-button @click="toggle_sim_details_sidebar($store.state.core.subscriber.infos)" pill variant="outline-secondary w-100">Afficher les détails</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "InfoSimWidget",
  data: function () {
    return {};
  },
  mounted: async function () {
  },
  methods: {
  },
};
</script>
<style scoped lang="css">
</style>
